<div class="portal-shell" [class.is-desktop]="isDesktop" [class.is-collapsed]="collapsed && isDesktop"
  [class.is-mobile-open]="mobileOpen && !isDesktop">
  <!-- Sidebar: fijo. En desktop su ancho lo marca --sidebar-w (colapsable);
       en móvil es un drawer fuera de lienzo que entra con translateX. -->
  <aside class="portal-sidebar">
    <app-portal-sidebar [collapsed]="collapsed && isDesktop" (toggleCollapse)="toggleCollapsed()"
      (navigate)="closeMobile()"></app-portal-sidebar>
  </aside>

  <!-- Backdrop del drawer (solo con móvil abierto) -->
  <div *ngIf="mobileOpen && !isDesktop" class="portal-backdrop" (click)="closeMobile()" (keydown.escape)="closeMobile()"></div>

  <!-- Contenido -->
  <div class="portal-content">
    <app-advisor-banner></app-advisor-banner>
    <app-toolbar (menu)="toggleMobile()"></app-toolbar>
    <div class="pt-20 mdx:pt-8 pb-4 bg-canvas">
      <div class="mx-4 md:mx-6 min-h-[100vh]">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</div>
